// extracted by mini-css-extract-plugin
module.exports = {"label":"AvailabilityLabel_label__k5LF0"};